import { render, staticRenderFns } from "./SessionsObjectivesChart.vue?vue&type=template&id=b9b1d3ca&"
import script from "./SessionsObjectivesChart.vue?vue&type=script&lang=js&"
export * from "./SessionsObjectivesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports